import { render, staticRenderFns } from "./RecentRunsList.vue?vue&type=template&id=10bdaca2&scoped=true"
import script from "./RecentRunsList.vue?vue&type=script&lang=js"
export * from "./RecentRunsList.vue?vue&type=script&lang=js"
import style0 from "./RecentRunsList.vue?vue&type=style&index=0&id=10bdaca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bdaca2",
  null
  
)

export default component.exports